/** Why a typed phone number will not do for a UK one. */
export type PhoneProblem = 'short' | 'long' | 'notUk';

/** A UK number's digits once +44 is a 0: ten for some landlines, eleven for the rest. */
const UK_MIN_DIGITS = 10;
const UK_MAX_DIGITS = 11;

const UK_CODE = '44';

/** What is wrong with a typed UK mobile or landline, or nothing; spaces, dashes and +44 are all fine. */
export const ukPhoneProblem = (typed: string): PhoneProblem | undefined => {
  const digits = typed.replace(/\D/g, '');
  // +44 (0)7700 drops the 0 in brackets, as +44 stands in for it.
  const national = digits.startsWith(UK_CODE)
    ? `0${digits.slice(UK_CODE.length).replace(/^0/, '')}`
    : digits;
  if (!national.startsWith('0')) return 'notUk';
  if (national.length < UK_MIN_DIGITS) return 'short';
  if (national.length > UK_MAX_DIGITS) return 'long';
  return undefined;
};
